const getPropertyMax =
  (propertyName: string) =>
  (objects: any): number =>
    objects.reduce(
      (max: number, current: any) =>
        current[propertyName] > max ? current[propertyName] : max,
      0
    );

export default getPropertyMax;
